import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ user, setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/login");
  };

  return (
    <div
      style={{
        width: "220px",
        background: "#2c3e50",
        color: "white",
        padding: "20px",
      }}
    >
      {/* Toggle Menu Button */}
      <h2
        style={{
          marginBottom: "20px",
          fontSize: "18px",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        Menu ☰
      </h2>

      {/* Menu Options - Show only if open */}
      {isMenuOpen && (
        <div>
          {/* Common buttons for all pages */}
          <button onClick={() => navigate("/gallery")} style={styles.sideButton}>
            Gallery
          </button>
          <button onClick={() => navigate("/projects")} style={styles.sideButton}>
            Projects
          </button>
          <button onClick={() => navigate("/")} style={styles.sideButton}>
            Home
          </button>

          {/* Page-specific buttons */}
          {location.pathname === "/" && (
            <>
              <button onClick={() => navigate("/login")} style={styles.sideButton}>
                Login
              </button>
            </>
          )}

          
          {location.pathname === "/admin/dashboard" && (
  <>
    { (
      <button
        onClick={() => navigate("/register")}
        style={styles.sideButton}
      >
        Register
      </button>
    )}

    {!user && (
      <button
        onClick={() => navigate("/admin/login")}
        style={styles.sideButton}
      >
        Admin Login
      </button>
    )}
    {user && (
      <button onClick={handleLogout} style={styles.sideButton}>
        Logout
      </button>
    )}
  </>
)}



          {location.pathname === "/login" && (
            <>
              {user && (
                <button onClick={handleLogout} style={styles.sideButton}>
                  Logout
                </button>
              )}
            </>
          )}
          {location.pathname === "/userdashboard" && (
            <>
              {user && (
                <button onClick={handleLogout} style={styles.sideButton}>
                  Logout
                </button>
              )}
            </>
          )}

          {location.pathname === "/dashboard" && (
            <>
              <button
                onClick={() => navigate("/change-password")}
                style={styles.sideButton}
              >
                Profile
              </button>
              {user && (
                <button onClick={handleLogout} style={styles.sideButton}>
                  Logout
                </button>
              )}
            </>
          )}

        </div>
      )}
    </div>
  );
};

const styles = {
  sideButton: {
    display: "block",
    width: "100%",
    padding: "10px",
    margin: "10px 0",
    background: "#34495e",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    textAlign: "left",
  },
};

export default Sidebar;
